import classNames from 'classnames';
import * as React from 'react';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import { FontIcon } from '../FontIcon';
import { border } from '@topconagriculture/theme';
import { Text } from '../Text';
const ExpansionPanel = withStyles(createStyles((theme) => ({
    root: {
        borderTop: border(theme.color.grey.light),
        boxShadow: 'none',
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})))(MuiExpansionPanel);
const ExpansionPanelSummary = withStyles(createStyles((theme) => ({
    root: {
        paddingLeft: theme.space.padding.small,
        backgroundColor: theme.color.grey.lightest,
        borderBottom: border(theme.color.grey.light),
        marginBottom: -1,
        minHeight: 50,
        '&$expanded': {
            minHeight: 50,
        },
    },
    content: {
        '&$expanded': {
            marginTop: theme.space.padding.small,
            marginBottom: theme.space.padding.small,
        },
    },
    expanded: {},
})))(MuiExpansionPanelSummary);
const ExpansionPanelDetails = withStyles(createStyles((theme) => ({
    root: {
        padding: theme.space.padding.small,
        display: 'block',
    },
})))(MuiExpansionPanelDetails);
const useStyles = makeStyles((theme) => ({
    details: {},
    expandIcon: {
        top: 2,
        lineHeight: 1,
        color: 'currentColor',
    },
    heading: {
        fontSize: theme.font.size.mediumBig,
        flexBasis: '33.3%',
        flexShrink: 0,
    },
    root: {
        width: '100%',
    },
}));
const Accordion = (props) => {
    const { children, classes: classesProp, className, heading, secondaryHeading, testId = 'Accordion', ...other } = props;
    const styles = useStyles();
    const classes = { ...styles, ...classesProp };
    const expandIcon = React.createElement(FontIcon, { className: classes.expandIcon, iconName: "accordion-down" });
    return (React.createElement(ExpansionPanel, Object.assign({ className: classNames(classes.root, className), "data-testid": `${testId}-panel` }, other),
        React.createElement(ExpansionPanelSummary, { "data-testid": `${testId}-summary`, expandIcon: expandIcon },
            React.createElement(Text, { bold: true, "data-testid": `${testId}-heading`, className: classes.heading }, heading),
            secondaryHeading && (React.createElement(Text, { "data-testid": `${testId}-caption`, type: 'caption' }, secondaryHeading))),
        React.createElement(ExpansionPanelDetails, { "data-testid": `${testId}-details`, className: classes.details }, children)));
};
export default Accordion;
//# sourceMappingURL=Accordion.js.map